import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingSample from '../../components/common/Loader/Loader';
import axios from 'axios';
import { config } from '../../config/env.config';
import { TokenResponse, UserData } from '../../types/api';
import StorageService from '../../services/StorageService';

const AUTH_API = config.api.auth;

const Redirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const codeFromURL = urlParams.get('code');
    const returnedState = urlParams.get('state');

    const savedState = StorageService.getOAuthState();
    StorageService.removeOAuthState();

    if (!returnedState || returnedState !== savedState) {
      navigate('/login');
      return;
    }

    if (codeFromURL) {
      const codeVerifier = StorageService.getCodeVerifier();

      if (!codeVerifier) {
        //console.error('Code verifier is missing, redirecting to login.');
        navigate('/login');
        return;
      }

      exchangeCodeForToken(codeFromURL, codeVerifier!)
        .then((data: TokenResponse | null) => {
          if (data) {
            const accessToken = data.access_token;
            if (data.refresh_token) {
              StorageService.setRefreshToken(data.refresh_token);
            }

            checkWhitelist(accessToken)
              .then(user => {
                if (user !== null) {
                  StorageService.setToken(accessToken);
                  StorageService.setUserData(user);
                  StorageService.removeCodeVerifier();
                  navigate('/');
                } else {
                  navigate('/login');
                }
              });
          } else {
            //console.error('Token exchange completed but no token received.');
            StorageService.clearAuth();
            navigate('/login');
          }
        })
        .catch(() => {
          StorageService.clearAuth();
          navigate('/login');
        });
    }
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      backgroundColor: '#f5f5f5',
      fontFamily: 'Helvetica Neue, sans-serif',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '12px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        padding: '48px 56px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px',
        minWidth: '360px',
      }}>
        <div style={{ fontSize: '20px', fontWeight: 600, color: '#1a1a1a', letterSpacing: '-0.3px' }}>
          Accesso in corso...
        </div>
        <div style={{ fontSize: '14px', color: '#666', marginTop: '-8px' }}>
          Verifica delle credenziali in corso, attendi.
        </div>
        <LoadingSample style={{ width: '280px' }} />
      </div>
    </div>
  );
};

async function exchangeCodeForToken(code: string, codeVerifier: string): Promise<TokenResponse | null> {
  const api_url = `${AUTH_API}/token`;
  try {
    const response = await axios.get(api_url, {
      params: {
        code: code,
        code_verifier: codeVerifier,
      }});

    //const token = response.data;
    if (!response) {
      throw new Error(`Token exchange failed`);
    }
    return response.data;
  } catch (error) {
    //console.error('Error exchanging code for token:', error);
    throw error;
  }
}

async function checkWhitelist(pwcIdentityToken: string): Promise<UserData | null> {
  try {
    const response = await axios.get(`${AUTH_API}/authorization`, {
      headers: {
        'pwc-identity-token': pwcIdentityToken
      }
    });
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error: any) {
    console.error('Errore whitelist check');
    return null;
  }
}

export default Redirect;
